module.exports = __webpack_public_path__ + "img/eventLoading1.8f4f2d92.gif";